import { render, staticRenderFns } from "./rolesList.vue?vue&type=template&id=03e61456&scoped=true"
import script from "./rolesList.vue?vue&type=script&lang=js"
export * from "./rolesList.vue?vue&type=script&lang=js"
import style0 from "./rolesList.vue?vue&type=style&index=0&id=03e61456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e61456",
  null
  
)

export default component.exports